import { IAppState } from '../../../common/state';

export const selectSelectedRegionalDistricts = (state: IAppState): number[] => {
  const { selectedDistricts } = state.filters.regionalDistrictsModal;

  return selectedDistricts.map(({ id }) => id);
};
